import axiosInstance from "../../../../setup/axios/SetupAxios";
const API_URL = process.env.REACT_APP_BASE_URL;

export const GET_NOTIFICATION_LIST_URL = `${API_URL}/api/v1/parent/notification`;

// export function getNotificationList(payload) {
//     const url = `${GET_NOTIFICATION_LIST_URL}?pageNo=${payload?.pageNo}&itemsPerPage=${payload?.itemsPerPage}&deviceId=${payload?.deviceId}&fromDate=${payload?.fromDate}&toDate=${payload?.toDate}&notificationType=[${payload?.notificationType}]`;
//     // return axiosInstance.get(GET_NOTIFICATION_LIST_URL, )
//     // const notficationIds = payload.notificationType;
//     // delete payload.notificationType;

//     return axiosInstance.get(url);

//     // return axiosInstance({
//     //     url: GET_NOTIFICATION_LIST_URL,
//     //     method: "GET",
//     //     params: {...payload,'notifictionType[]': notficationIds}
//     // })
// }

export function getNotificationList(payload) {
    // Initialize the base URL with pageNo and itemsPerPage
    let url = `${GET_NOTIFICATION_LIST_URL}?pageNo=${payload?.pageNo}&itemsPerPage=${payload?.itemsPerPage}`;
    
    // Conditionally add deviceId to the URL if it exists
    if (payload?.deviceId) {
        url += `&deviceId=${payload?.deviceId}`;
    }

    // Conditionally add fromDate to the URL if it exists
    if (payload?.fromDate) {
        url += `&fromDate=${payload?.fromDate}`;
    }

    // Conditionally add toDate to the URL if it exists
    if (payload?.toDate) {
        url += `&toDate=${payload?.toDate}`;
    }

    // Conditionally add notificationType to the URL if it has values
    if (payload?.notificationType && payload?.notificationType.length > 0) {
        url += `&notificationType=[${payload?.notificationType}]`;
    }

    // Make the GET request with the constructed URL
    return axiosInstance.get(url);
}
